import React, { useEffect, useState } from "react";
import api from 'api';
import { Link, useNavigate, useLocation  } from 'react-router-dom';
import { API } from "common/config-api"; // jsconfig.json
import Pagination from "common/Pagination";

const ProductTr = ({p}) => {
  const navigate = useNavigate();
  //const pageProductDetail = (productIdx) => { navigate('/product/detail/' + productIdx); }
  return (
  <tr>
    <td style={{wordBreak: "break-all"}}>
      <Link to={`/product/${p.productCode}`}>
        <b><i className="ri-bug-fill"></i>&nbsp;&nbsp;{p.productName}</b>
      </Link>
    </td>
    {/*<td>{p.productType}</td>*/}
    <td>{p.productCategory}</td>
    <td>{p.productManufactureNickname ? p.productManufactureNickname : "-"}</td>
    <td>￥{p.productPrice.toLocaleString('ko-KR')}</td>
    <td>{p.productAccumulate}</td>
  </tr>    
  );
}


const ProductList = () => {

  const location = useLocation();

  const navigate = useNavigate();

  const [productList, setProductList] = useState([]);

  const [curPage, setCurPage] = useState(0); //현재 페이지 (0-based)
  const [totalPages, setTotalPages] = useState(0); //전체 페이지 수

  const [search, setSearch] = useState({
    pageNumber: 1,
    size: 20,
    keyword: '',
    productManufactureNickname: '',
  });

  const getBoardList = async () => {
    try {
      const queryString = Object.entries(search)
        .map((e) => e.join('='))
        .join('&');

      console.log("url", `${API.PRODUCT_LIST}?` + queryString);

      const response = await api.get(`${API.PRODUCT_LIST}?` + queryString);
      const resp = response;

      console.log("resp", resp);

      // Page<> 응답 처리
      const productListData = resp?.content || [];
      const pageInfo = resp?.page;

      setProductList(productListData);
      setCurPage(pageInfo?.number || 0);
      setTotalPages(pageInfo?.totalPages || 1);

      console.log("Product List Data:", productListData);
      console.log("Current Page:", pageInfo?.number, "Total Pages:", pageInfo?.totalPages);
    } catch (error) {
      console.error('상품 목록 조회 실패:', error);
      alert('상품 목록 조회 중 오류가 발생했습니다.');
    }
  };

  const moveToWrite = () => {
    navigate('/write');
  };


  const onPageChange = (page) => {
    // page는 1-based 페이지 번호
    setSearch({
      ...search,
      pageNumber: page,
    });
  };

  const onChange = (event) => {
    const { value, name } = event.target;
    setSearch({
      ...search,
      [name]: value,
      pageNumber: 1,
    });
  };

  const onSearch = () => {
    console.log("onSearch");
    console.log("keywordLength", search.keyword.length);
    setSearch({
      ...search,
      pageNumber: 1,
    });
  };

  useEffect(() => {
    getBoardList(); // 1) 게시글 목록 조회 함수 호출
  }, [search]);






    return (

        <div className="row">

          <div className="card">
            <div className="card-body">
              <h5 className="card-title">product list</h5>


                <div className="row mb-3">
                  <div className="col-sm-4">
                    <input type="text" onChange={onChange} name="keyword" className="form-control" placeholder="상품명" />
                  </div>

                  <div className="col-sm-2">
                    <input type="text" onChange={onChange} name="productManufactureNickname" className="form-control" placeholder="생산처(딜러)" />
                  </div>

                  <div className="col-sm-2">
                    <select className="form-select" onChange={onChange} name="productCategory" aria-label="카테고리" defaultValue={'dutyfree'}>
                      <option value="duty">카테고리</option>
                      <option value="nonduty">피규어</option>
                      <option value="dutyfree">옵션파츠</option>
                      <option value="dutyfree1">프라모델</option>
                      <option value="dutyfree2">데칼</option>
                      <option value="dutyfree3">에칭</option>
                    </select>
                  </div>

                  <div className="col-sm-2">
                    <select className="form-select" onChange={onChange} name="productType" aria-label="매입구분" defaultValue={''}>
                      <option value="">매입구분</option>
                      <option value="0">딜러 위탁</option>
                      <option value="1">사입</option>
                      <option value="2">매장 자체상품</option>
                      <option value="3">기타</option>
                    </select>
                  </div>

                  <div className="col-sm-2">
                    <button type="button" onClick={onSearch} className="btn btn-primary">Search</button>
                  </div>

                </div>


              <table className="table table-hover">
                <thead>
                  <tr>
                    <th scope="col" width="50%">상품명</th>
                    <th scope="col">상품군</th>
                    <th scope="col">딜러(제조사)</th>
                    <th scope="col">가격</th>
                    <th scope="col">
                      누적판매
                    </th>
                  </tr>
                </thead>
                <tbody>
                {productList.map((product, idx) => ( <ProductTr key={idx} p={product} /> ))}
                </tbody>
              </table>

              <Pagination
                currentPage={curPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
              />

            </div>
          </div>
        </div>


    );

}

export default ProductList;


